import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { FontFamilySelect as LocalFontFamily } from '../../components/FontFamilySelect'

export const FontFamilySelect = connect(
  LocalFontFamily,
  mapReadPretty(LocalFontFamily, { disabled: true })
)
